<template>
  <b-modal
    id="boost-modal"
    size="md"
    centered
    body-class="modal-body-scrollable p-0"
    title="U Beauty Boosts"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <div class="p-1">
      <div class="header rounded">
        <h4 class="font-weight-bolder mb-0 text-white">
          {{ pagination.total || items.length }} Boosts
        </h4>
      </div>
    </div>

    <div class="px-1">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        class="p-1 mb-1 rounded shadow-lg"
      >
        <div class="text-black">
          <div class="d-flex align-items-center">
            <div
              class="boost-icon d-flex align-items-center justify-content-center rounded-circle"
              style="
                margin-right: 8px;
                width: 20px;
                height: 20px;
                background: #dbd4f2;
              "
            >
              <feather-icon icon="ZapIcon" style="color: #846cf7" />
            </div>
            <span class="font-weight-bold">
              {{ item.remainingUses }}x {{ item.name }}
            </span>
          </div>
          <div style="margin-top: 8px">
            <span class="text-muted mr-1"> Expires:</span>
            <b-badge class="boost-expire" style="background: #dad2f2">
              <span class="font-weight-bolder" style="color: #846cf7">{{
                format(new Date(item.endTime), "MMM d, yyyy h:mm a")
              }}</span>
            </b-badge>
          </div>
          <div
            class="d-flex align-items-center"
            style="margin-top: 8px; gap: 8px"
          >
            <div class="d-flex align-items-center" style="gap: 8px">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-7"
              >
                <path
                  d="M7.73412 3.82859C8.61527 3.82859 9.33082 2.97156 9.33082 1.91617C9.33082 0.860778 8.61527 0 7.73412 0C6.85297 0 6.13743 0.860778 6.13743 1.91617C6.13743 2.97156 6.85297 3.82859 7.73412 3.82859Z"
                  fill="#000"
                ></path>
                <path
                  d="M2.10351 4.46108C1.67231 4.95509 1.48171 5.66991 1.59732 6.36976C1.70981 7.06213 2.10351 7.63473 2.65032 7.89671L4.75321 8.91093L4.16578 11.86C4.08766 12.2418 4.26577 12.631 4.57511 12.7582C4.64385 12.7882 4.71259 12.7994 4.78446 12.7994C5.03443 12.7994 5.2719 12.6198 5.37189 12.3278L6.49364 9.0756C6.75611 8.30838 6.49364 7.43638 5.87808 7.04716L4.50011 6.17889C4.75009 5.84581 5.05943 5.58009 5.44063 5.37425L5.64373 6.42216C5.74372 6.93488 6.13118 7.27545 6.56863 7.23428L8.59965 7.04716C8.92774 7.01347 9.18396 6.68413 9.18396 6.29117C9.18396 5.89446 8.93711 5.56886 8.6059 5.53518L6.95921 5.36677C6.95921 5.36677 6.95609 5.36677 6.95609 5.36302L6.88734 4.375C6.18117 4.02695 5.65311 3.2485 5.54062 2.31287C4.33763 2.5 3.18151 3.2223 2.10351 4.46108Z"
                  fill="#000"
                ></path>
                <path
                  d="M0.0506193 7.78443C-0.00562433 7.88548 -0.0149983 8.01647 0.0224974 8.12874C0.888024 10.6999 2.47534 15 3.42836 15H3.43774C3.45961 15 3.48148 14.9963 3.50335 14.9888L6.00619 14.2552C7.79974 13.7275 9.30582 12.3728 10.1464 10.5389C10.7057 9.30763 11.4806 8.64895 11.7618 8.43937L13.6272 9.21407C14.0053 9.375 14.4584 9.24027 14.7302 8.88099C14.9146 8.63772 15.0114 8.32335 14.9989 7.99027C14.9833 7.65719 14.8614 7.3503 14.6552 7.12949L12.6648 4.98503L12.7679 3.65644C12.7804 3.51796 12.7242 3.38323 12.6242 3.30838C12.5273 3.22979 12.4023 3.22979 12.2992 3.29716C11.693 3.72006 11.4087 4.43862 11.2931 4.82036C10.74 4.92889 10.1776 5.1497 9.61204 5.47156C9.73702 5.70733 9.80889 5.98802 9.80889 6.29117C9.80889 7.06587 9.3027 7.72455 8.65277 7.79192L7.16856 7.93039C7.25918 8.39072 7.23418 8.88847 7.0717 9.36003L5.94995 12.6123C5.75622 13.1811 5.2969 13.5479 4.78446 13.5479C4.63448 13.5479 4.49387 13.518 4.36263 13.4618C3.75332 13.2111 3.40336 12.4439 3.5596 11.6804L4.01892 9.36377L2.41598 8.59281C1.98165 8.38323 1.61607 8.03144 1.35985 7.58233L0.303716 7.61602C0.203727 7.61976 0.106863 7.67964 0.0506193 7.78443Z"
                  fill="#000"
                ></path></svg
              ><svg
                width="24"
                height="7"
                viewBox="0 0 24 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-7 h-8"
              >
                <path
                  d="M22.5504 3.06631C22.0254 2.63272 21.4466 2.24357 20.9253 1.80352C20.6007 0.53319 19.0097 -0.566131 17.7679 0.455898C17.6551 0.54881 17.3781 0.893525 17.2673 0.897296C15.2676 0.29916 13.1596 0.0820967 11.0643 0.0128842C9.83053 -0.0277815 8.88896 0.0128842 7.69936 0.354638C5.77745 0.906452 4.0852 2.18002 1.98044 1.37128C1.5685 1.21293 1.20995 0.980512 0.859445 0.726284C0.646729 0.644145 0.583575 0.914801 0.646442 1.06104C0.70931 1.20727 1.41262 1.69741 1.58773 1.79383C2.57294 2.33595 3.79211 2.32463 4.88985 2.18944C5.31757 2.13666 5.74243 2.03863 6.17131 2.00496C6.17073 2.02678 6.17533 2.04994 6.17102 2.07175C6.1604 2.12481 5.72808 2.63246 5.65402 2.71783C5.02247 3.44469 4.27007 4.16806 3.27137 4.41447C2.59016 4.58279 1.70543 4.49527 1.13388 4.91377C0.706152 5.22698 -0.0402189 6.21158 0.00169268 6.72757C0.00800812 6.80486 0.10274 6.93548 0.178525 6.96672C0.398705 7.05748 0.69266 6.94679 0.874085 6.82452C1.55587 6.36481 1.85585 5.78284 2.77704 5.62044C4.24165 5.36217 5.34599 5.51029 6.77989 4.87823C7.73036 4.45945 8.29186 3.8842 9.1189 3.38302C9.58251 3.10213 9.74384 3.15438 10.1707 3.43634C10.6283 3.73878 10.9877 4.12604 11.484 4.41259C12.6561 5.08909 14.003 5.15373 15.3057 4.77077C15.509 4.71098 15.7019 4.61188 15.9109 4.56663C15.9864 4.58468 16.4193 5.02904 16.5367 5.11279C17.068 5.49225 18.305 5.59163 18.9796 5.72951C19.873 5.91183 20.7399 6.19192 21.6014 6.47469C22.1861 6.66671 23.3886 7.30686 23.9013 6.81564C24.2051 6.52478 23.7323 6.28644 23.4957 6.15044C22.1531 5.37914 20.5613 4.95713 19.1363 4.31698C18.8651 4.19499 17.8844 3.74605 18.7594 3.67495C19.4131 3.6219 20.3937 3.98573 21.0631 4.09804C21.7291 4.2098 22.1413 4.16779 22.6061 3.67495C22.9239 3.33805 22.8567 3.31919 22.5504 3.06631Z"
                  fill="#000"
                ></path></svg
              ><svg
                width="24"
                height="15"
                viewBox="0 0 24 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-7"
              >
                <path
                  d="M20.6307 1.77186C21.1941 2.47288 21.9437 3.17247 22.6092 3.78931C22.8424 4.00544 23.2107 4.24518 23.4052 4.47213C23.8904 5.03749 23.3352 5.80363 22.6524 5.7368C22.2722 5.69955 21.9682 5.41089 21.6218 5.2886C21.3789 5.203 21.1059 5.17087 20.8596 5.08384C20.668 5.01616 20.4953 4.90895 20.3054 4.83927L19.5449 6.21258C19.3419 6.73699 19.3057 7.31117 19.1803 7.85407C19.1126 8.14728 18.9813 8.42256 18.8558 8.69415C18.8922 8.69358 18.9281 8.70155 18.9611 8.7169C19.3373 8.89067 19.6971 9.07779 20.0688 9.25923C20.4834 9.46172 20.7948 9.4785 21.0508 9.89825C21.5752 10.758 22.1545 11.8156 22.6149 12.7137C22.6672 12.8158 22.8091 13.1027 22.8097 13.2017C22.8106 13.4082 22.5381 13.6382 22.3257 13.566C22.1946 13.5214 21.7748 13.3229 21.652 13.2503C21.2612 13.0188 21.4116 12.7936 21.3522 12.441C21.3218 12.2612 20.5189 10.9391 20.3642 10.7272C19.9758 10.1946 19.4735 10.2938 18.8783 10.194C18.6147 10.1499 18.3684 10.0646 18.1085 10.0362C18.0672 10.0478 17.7709 10.4884 17.724 10.5623C17.3679 11.1208 17.2041 11.8125 16.7798 12.3198C16.3282 12.8602 15.6067 13.3649 15.0573 13.7949C14.9705 13.8629 14.8761 13.9971 14.7615 14.0131C14.8716 14.2912 15.2578 14.6748 14.7968 14.8583C14.5951 14.9385 13.8424 14.8105 13.6663 14.6956C13.637 14.6763 13.4957 14.5318 13.4877 14.5045C13.4442 14.3575 13.4749 14.0085 13.5546 13.87C13.3947 13.7153 13.1914 13.6041 13.0267 13.4585C12.746 13.2102 12.5063 12.8997 12.2467 12.646C11.983 12.3886 11.6105 12.1293 11.3662 11.8486C11.1023 11.5451 11.375 11.1698 11.4609 10.8663C11.4916 10.7577 11.5371 10.4977 11.5479 10.3863C11.551 10.3541 11.5715 10.2301 11.5203 10.2304C11.4592 10.3888 11.2556 10.4901 11.1131 10.5771C10.8273 10.7514 10.3947 10.9883 10.089 11.1169C9.47501 11.3754 9.22106 11.3759 8.83486 11.9956C8.3713 12.739 8.08066 13.5216 7.50875 14.2175C7.333 14.4314 6.82565 15.0042 6.51453 14.8233C6.48695 14.8074 6.30408 14.36 6.29441 14.3043C6.25574 14.0816 6.26967 13.8245 6.45168 13.6709C6.65445 13.4995 6.8794 13.547 7.08388 13.2589C7.55113 12.6002 7.82385 11.734 8.28314 11.0739C8.60962 10.6047 9.25433 10.3186 9.50601 9.79417C9.80092 9.17932 9.54981 8.88868 9.50146 8.31051C9.48497 8.11144 9.55777 7.90355 9.52933 7.69936L7.22607 8.49594C7.18938 8.5457 7.7155 9.41053 7.73882 9.61813C7.79741 10.1431 7.24882 10.5936 6.74858 10.4093C6.36836 10.2691 6.20597 9.69833 5.95997 9.40541L5.22256 10.1462C5.12473 10.2987 5.21402 10.2887 5.26294 10.3652C5.70061 11.0512 5.92471 11.7101 5.79588 12.5397C5.41082 15.017 2.30075 15.8744 0.685993 13.9405C-0.84231 12.1102 0.335058 9.31896 2.71738 9.14832C3.4147 9.09827 4.05941 9.40996 4.64838 9.74383L5.54761 8.82241C5.52173 8.79142 5.4913 8.76809 5.44978 8.76468C5.2473 8.7479 4.99675 8.82839 4.79569 8.83805C4.41774 8.85626 4.03438 8.82128 3.65586 8.83805C2.98584 8.71008 2.2106 8.9137 1.55196 8.83749C1.38673 8.81843 1.37563 8.73112 1.3472 8.58751C1.23429 8.01503 1.67168 8.05855 2.094 8.06793C2.85218 8.08471 3.51338 8.12623 4.28151 8.09637C4.37678 8.09267 5.03799 8.13163 5.03571 8.02641C4.98338 7.99712 4.95068 7.89076 4.90376 7.87455C4.77948 7.83189 4.29289 7.8808 4.1123 7.86971C2.80326 7.78866 1.69614 7.08423 2.55016 5.68248C3.01513 4.91947 3.65927 4.19542 4.14273 3.4361C4.3273 3.19863 4.57074 3.02402 4.87105 2.97056C5.96566 2.77575 6.62231 3.855 7.30257 4.50967C7.70271 4.4306 8.09886 4.33022 8.49501 4.23352C8.70233 4.1829 8.90026 4.07882 9.11782 4.08621C9.41643 4.09616 9.65873 4.30604 9.78358 4.5583L9.82822 4.57337C9.93146 4.56796 10.0392 4.52673 10.1408 4.52047C10.5918 4.4926 11.0744 4.51677 11.5354 4.51336C12.5729 4.50625 13.6168 4.52161 14.6614 4.54408C15.4014 4.56 16.1405 4.55858 16.8811 4.57138L16.9382 4.54322C17.1797 4.13058 17.513 3.77082 17.8616 3.44747C18.2194 3.11588 18.659 2.78286 19.0762 2.52918C19.2031 2.45212 19.6174 2.27153 19.6831 2.19759C19.8302 2.03236 19.8606 1.49373 20.1242 1.44453C20.4385 1.38594 20.472 1.5725 20.6324 1.77214L20.6307 1.77186ZM5.03429 6.39089H5.56041C5.99268 6.39089 6.33423 6.75519 6.52448 7.10471L6.80432 7.72012L6.89191 7.74828C7.8685 7.29184 8.84339 6.88715 9.93146 6.78705C10.5841 5.90288 11.5178 5.61593 12.5834 5.56503C13.0691 5.54199 13.5509 5.63527 14.0338 5.65262C14.8255 5.68134 15.692 5.63129 16.3242 5.11143C15.1582 5.01559 13.9817 5.05797 12.8103 5.05512C12.3422 5.05398 11.8622 5.03209 11.3946 5.03635C10.8554 5.04147 10.3137 5.06564 9.77362 5.05882C9.6155 5.29884 9.30893 5.4436 9.04331 5.55109C8.95828 5.58551 8.86699 5.59091 8.79703 5.61821C8.2547 5.82866 7.30257 6.31411 6.76138 5.9919L5.92983 5.16802L5.03372 6.39089H5.03429ZM16.5196 9.74355L16.5233 9.70459C16.4892 9.62609 15.9995 9.66961 15.884 9.66107C15.549 9.63662 15.1409 9.57263 14.8059 9.5186C14.3335 9.44238 13.8637 9.33204 13.3956 9.23506C13.4041 9.88546 13.1638 10.4648 12.8698 11.027C12.7987 11.1629 12.5774 11.4419 12.5743 11.5818C12.5717 11.6876 12.8075 11.8452 12.8735 11.918C13.0902 12.1574 13.2198 12.3116 13.4587 12.5348C13.7479 12.805 14.0232 13.1093 14.3736 13.2995C14.7035 12.9495 15.1096 12.6722 15.458 12.3355C16.0034 11.8079 16.0302 11.6939 16.2207 10.9627C16.3191 10.5848 16.3677 10.1212 16.4676 9.7663C16.4747 9.74099 16.517 9.74781 16.5199 9.74355H16.5196ZM4.09581 10.2873C3.95219 10.2483 3.84498 10.1502 3.70506 10.0948C1.61225 9.26435 -0.176272 11.7473 1.25733 13.4255C2.5604 14.951 4.90944 14.1635 5.08776 12.2032C5.12785 11.7636 4.90233 11.1166 4.59349 10.7992C4.58069 10.7938 4.56477 10.8615 4.53775 10.8848C4.11316 11.25 3.72582 11.668 3.32739 12.0639C3.20852 12.1819 3.07827 12.4026 2.8883 12.3926C2.68041 12.3818 2.37441 12.067 2.56011 11.8654L4.09581 10.2873Z"
                  fill="#000"
                ></path>
                <path
                  d="M6.96616 3.06514C7.81258 3.06514 8.49873 2.37898 8.49873 1.53257C8.49873 0.686154 7.81258 0 6.96616 0C6.11975 0 5.43359 0.686154 5.43359 1.53257C5.43359 2.37898 6.11975 3.06514 6.96616 3.06514Z"
                  fill="#000"
                ></path>
              </svg>
            </div>
            <span class="font-weight-bolder">{{ item.subType }}</span>
          </div>
        </div>
      </div>

      <div ref="loadMoreTrigger" style="height: 1px"></div>
    </div>

    <div v-if="loading" class="px-1">
      <b-skeleton
        v-for="n in 3"
        :key="n"
        type="text"
        height="90px"
        class="rounded w-100"
      />
    </div>

    <div
      v-if="!loading && items.length === 0"
      class="text-center my-4 text-muted"
    >
      No boosted promotions found.
    </div>

    <template #modal-footer>
      <b-button block variant="primary" class="done-btn" @click="onModalHidden">
        DONE
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BSkeleton, BButton, BBadge } from "bootstrap-vue";
import { mapActions } from "vuex";
import { format } from "date-fns";

export default {
  components: {
    BModal,
    BSkeleton,
    BButton,
    BBadge,
  },

  data() {
    return {
      items: [],
      loading: false,
      hasMore: true,
      observer: null,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  methods: {
    ...mapActions("user/detail", ["getBoostedPromotions"]),
    format,
    async handleFetchBoosts() {
      if (this.loading || !this.hasMore) return;
      const userId = this.$route.params.id;
      if (!userId) return;
      try {
        this.loading = true;
        const result = await this.getBoostedPromotions({
          userId,
          page: this.pagination.page,
          type: "Boost",
        });
        this.items.push(...result.data);
        this.pagination = result.pagination;
        this.hasMore = this.items.length < this.pagination.total;
      } finally {
        this.loading = false;
      }
    },

    initIntersectionObserver() {
      if (this.observer) return;
      const modalBody = document.querySelector(".modal-body-scrollable");
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.pagination.page++;
            this.handleFetchBoosts();
          }
        },
        {
          root: modalBody,
          rootMargin: "120px",
        }
      );
      this.$nextTick(() => {
        this.$refs.loadMoreTrigger &&
          this.observer.observe(this.$refs.loadMoreTrigger);
      });
    },

    resetData() {
      this.items = [];
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0,
      };
      this.hasMore = true;
    },

    async onModalShown() {
      this.resetData();
      await this.handleFetchBoosts();
      this.initIntersectionObserver();
    },

    onModalHidden() {
      this.observer?.disconnect();
      this.observer = null;
      this.$bvModal.hide("boost-modal");
      this.resetData();
    },
  },
};
</script>

<style scoped>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}

.header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(90deg, #0b0e1f, #1a2cff);
}
</style>
